import React from 'react';
import { AnalyticsContext } from './analytics-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const AnalyticsContextProvider = /* @__PURE__ */ __name(({
  children,
  sendAnalytics
}) => /* @__PURE__ */ React.createElement(AnalyticsContext.Provider, {
  value: { sendAnalytics }
}, children), "AnalyticsContextProvider");

export { AnalyticsContextProvider };
//# sourceMappingURL=analytics-context-provider.js.map
